import * as ambassadorWixPortfolioProjectsV1Project from './portfolio-projects-v1-project-projects.http.js';
import * as ambassadorWixPortfolioProjectsV1ProjectTypes from './portfolio-projects-v1-project-projects.types.js';
import * as ambassadorWixPortfolioProjectsV1ProjectUniversalTypes from './portfolio-projects-v1-project-projects.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createProject(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.CreateProjectRequest,
  ambassadorWixPortfolioProjectsV1ProjectTypes.CreateProjectRequest,
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.CreateProjectResponse,
  ambassadorWixPortfolioProjectsV1ProjectTypes.CreateProjectResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectsV1Project.createProject(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/portfolio/projects',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getProject(): __PublicMethodMetaInfo<
  'GET',
  { projectId: string },
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.GetProjectRequest,
  ambassadorWixPortfolioProjectsV1ProjectTypes.GetProjectRequest,
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.GetProjectResponse,
  ambassadorWixPortfolioProjectsV1ProjectTypes.GetProjectResponse
> {
  const payload = { projectId: ':projectId' } as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectsV1Project.getProject(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/portfolio/projects/{projectId}',
    pathParams: { projectId: 'projectId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listProjects(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.ListProjectsRequest,
  ambassadorWixPortfolioProjectsV1ProjectTypes.ListProjectsRequest,
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.ListProjectsResponse,
  ambassadorWixPortfolioProjectsV1ProjectTypes.ListProjectsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectsV1Project.listProjects(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/portfolio/projects',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateProject(): __PublicMethodMetaInfo<
  'PATCH',
  { projectId: string },
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.UpdateProjectRequest,
  ambassadorWixPortfolioProjectsV1ProjectTypes.UpdateProjectRequest,
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.UpdateProjectResponse,
  ambassadorWixPortfolioProjectsV1ProjectTypes.UpdateProjectResponse
> {
  const payload = { project: { id: ':projectId' } } as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectsV1Project.updateProject(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/portfolio/projects/{project.id}',
    pathParams: { projectId: 'projectId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateProjects(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.BulkUpdateProjectsRequest,
  ambassadorWixPortfolioProjectsV1ProjectTypes.BulkUpdateProjectsRequest,
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.BulkUpdateProjectsResponse,
  ambassadorWixPortfolioProjectsV1ProjectTypes.BulkUpdateProjectsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectsV1Project.bulkUpdateProjects(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/bulk/portfolio/projects/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteProject(): __PublicMethodMetaInfo<
  'DELETE',
  { projectId: string },
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.DeleteProjectRequest,
  ambassadorWixPortfolioProjectsV1ProjectTypes.DeleteProjectRequest,
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.DeleteProjectResponse,
  ambassadorWixPortfolioProjectsV1ProjectTypes.DeleteProjectResponse
> {
  const payload = { projectId: ':projectId' } as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectsV1Project.deleteProject(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/api/v1/portfolio/projects/{projectId}',
    pathParams: { projectId: 'projectId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryProjects(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.QueryProjectsRequest,
  ambassadorWixPortfolioProjectsV1ProjectTypes.QueryProjectsRequest,
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.QueryProjectsResponse,
  ambassadorWixPortfolioProjectsV1ProjectTypes.QueryProjectsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectsV1Project.queryProjects(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/portfolio/projects/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateProjectOrderInCollection(): __PublicMethodMetaInfo<
  'PATCH',
  { projectId: string; collectionId: string },
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.UpdateProjectOrderInCollectionRequest,
  ambassadorWixPortfolioProjectsV1ProjectTypes.UpdateProjectOrderInCollectionRequest,
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.UpdateProjectOrderInCollectionResponse,
  ambassadorWixPortfolioProjectsV1ProjectTypes.UpdateProjectOrderInCollectionResponse
> {
  const payload = {
    projectId: ':projectId',
    collectionId: ':collectionId',
  } as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectsV1Project.updateProjectOrderInCollection(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/portfolio/projects/{projectId}/collections/{collectionId}',
    pathParams: { projectId: 'projectId', collectionId: 'collectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryProjectsWithCollectionInfo(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.QueryProjectWithCollectionInfoRequest,
  ambassadorWixPortfolioProjectsV1ProjectTypes.QueryProjectWithCollectionInfoRequest,
  ambassadorWixPortfolioProjectsV1ProjectUniversalTypes.QueryProjectWithCollectionInfoResponse,
  ambassadorWixPortfolioProjectsV1ProjectTypes.QueryProjectWithCollectionInfoResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectsV1Project.queryProjectsWithCollectionInfo(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/1/portfolio/projects/collections/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Project as ProjectOriginal,
  ProjectCoverOneOf as ProjectCoverOneOfOriginal,
  Image as ImageOriginal,
  ImageType as ImageTypeOriginal,
  ImageTypeWithLiterals as ImageTypeWithLiteralsOriginal,
  CommonImage as CommonImageOriginal,
  Point as PointOriginal,
  UnsharpMasking as UnsharpMaskingOriginal,
  Video as VideoOriginal,
  VideoV2 as VideoV2Original,
  VideoResolution as VideoResolutionOriginal,
  ProjectDetail as ProjectDetailOriginal,
  ProjectDetailValueOneOf as ProjectDetailValueOneOfOriginal,
  DetailsLink as DetailsLinkOriginal,
  ProjectSource as ProjectSourceOriginal,
  SyncStatus as SyncStatusOriginal,
  SyncStatusWithLiterals as SyncStatusWithLiteralsOriginal,
  PageUrlV2 as PageUrlV2Original,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  Watermark as WatermarkOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  MenuSettingUpdatedEvent as MenuSettingUpdatedEventOriginal,
  GetProjectPageDataRequest as GetProjectPageDataRequestOriginal,
  GetProjectPageDataResponse as GetProjectPageDataResponseOriginal,
  ProjectSlug as ProjectSlugOriginal,
  CreateNewPortfolioAppRequest as CreateNewPortfolioAppRequestOriginal,
  CreateNewPortfolioAppResponse as CreateNewPortfolioAppResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  SyncProjectWithCollectionMappings as SyncProjectWithCollectionMappingsOriginal,
  DeletedProjectRestored as DeletedProjectRestoredOriginal,
  CreateProjectRequest as CreateProjectRequestOriginal,
  CreateProjectResponse as CreateProjectResponseOriginal,
  GetProjectRequest as GetProjectRequestOriginal,
  GetProjectResponse as GetProjectResponseOriginal,
  ListProjectsRequest as ListProjectsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListProjectsResponse as ListProjectsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  UpdateProjectRequest as UpdateProjectRequestOriginal,
  UpdateProjectResponse as UpdateProjectResponseOriginal,
  BulkUpdateProjectsRequest as BulkUpdateProjectsRequestOriginal,
  MaskedProject as MaskedProjectOriginal,
  BulkUpdateProjectsResponse as BulkUpdateProjectsResponseOriginal,
  BulkUpdateProjectsResult as BulkUpdateProjectsResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  DeleteProjectRequest as DeleteProjectRequestOriginal,
  DeleteProjectResponse as DeleteProjectResponseOriginal,
  QueryProjectsRequest as QueryProjectsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryProjectsResponse as QueryProjectsResponseOriginal,
  UpdateProjectOrderInCollectionRequest as UpdateProjectOrderInCollectionRequestOriginal,
  UpdateProjectOrderInCollectionResponse as UpdateProjectOrderInCollectionResponseOriginal,
  ProjectsInCollections as ProjectsInCollectionsOriginal,
  QueryProjectWithCollectionInfoRequest as QueryProjectWithCollectionInfoRequestOriginal,
  QueryProjectWithCollectionInfoResponse as QueryProjectWithCollectionInfoResponseOriginal,
  RestoreProjectFromTrashBinRequest as RestoreProjectFromTrashBinRequestOriginal,
  RestoreProjectFromTrashBinResponse as RestoreProjectFromTrashBinResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  GetAdjacentProjectInfoRequest as GetAdjacentProjectInfoRequestOriginal,
  GetAdjacentProjectInfoResponse as GetAdjacentProjectInfoResponseOriginal,
  ProjectInfo as ProjectInfoOriginal,
} from './portfolio-projects-v1-project-projects.types.js';
